module.exports = __webpack_public_path__ + "static/media/neutralwizard.7cd74b71.gif";